<template>
  <div>
    <modal-form v-model="show" :submit="submit" size="lg">
      <template v-slot:title>
        <v-icon class="mr-2">fas fa-edit</v-icon>
        {{ model.Codigo ? "Editar" : "Nova" }} Garantia
      </template>
      <template v-slot:body>
        <v-row>
          <v-col cols="6">
            <input-text label="Tipo de Operação" :value="model.TipoOperacaoNome" readonly disabled />
          </v-col>
          <v-col cols="6">
            <input-text label="Produto" :value="model.TipoContratoDescricao" readonly disabled />
          </v-col>
          <v-col cols="6">
            <input-select :disabled="model.Codigo != null"
                          label="Grupo"
                          v-model="model.Grupo"
                          @change="changeGrupo"
                          :options="bens"
                          required />
          </v-col>
          <v-col cols="6">
            <input-select :disabled="model.Codigo != null"
                          label="Tipo de Garantia"
                          v-model="model.Subgrupo"
                          :options="tipoGarantia"
                          @change="changeSubgrupo"
                          required />
          </v-col>
        </v-row>
        <v-col cols="12">
          <span class="text-subtitle-2">Informações do Proprietário</span>
          <v-divider></v-divider>
        </v-col>
        <input-radiogroup
              v-model="model.Proprietario"
              @change="changeProprietario"
              class="ml-2"
              row>
          <v-radio :value="1">
            <template
              slot="label">
              <span class="mr-2">Emitente</span>
            </template>
          </v-radio>
          <v-radio :value="2" v-if="!isSAC">
            <template slot="label">
              <span>Terceiro Garantidor</span>
            </template>
          </v-radio>
        </input-radiogroup>
        <v-row>
          <v-col cols="6">
            <input-documento v-if="model.Proprietario === 1" label="CPF/CNPJ do Proprietário" :value="model.DocumentoFederalProprietario" readonly disabled />
            <input-documento v-else label="CPF do Proprietário" v-model="model.DocumentoFederalProprietario" cpf required/>
          </v-col>
          <v-col cols="6">
            <input-text v-if="model.Proprietario === 1" label="Nome do Proprietário" :value="model.NomeProprietario" readonly disabled />
            <input-text v-else label="Nome do Proprietário" v-model="model.NomeProprietario" required/>
          </v-col>
        </v-row>
        <v-row v-if="model.Subgrupo">
          <v-col cols="12">
            <BemImovel :chave="chave" v-model="model.PropostaGarantiaBemImovel" v-if="model.Grupo === $api.Estruturadas.GrupoBemEnum.BemImovel" />
            <BemMovel :chave="chave" v-model="model.PropostaGarantiaBemMovel" v-if="model.Grupo === $api.Estruturadas.GrupoBemEnum.BemMovel && chave !== 1" />
            <BemVeiculo @loadVlrRegistro="getValorRegistro" :chave="chave" v-model="model.PropostaGarantiaBemVeiculo" v-if="model.Grupo === $api.Estruturadas.GrupoBemEnum.BemMovel && chave === 1" :vlrRegistro="vlrRegistro"/>
            <BemFinanceiro :chave="chave" v-model="model.PropostaGarantiaBemFinan" v-if="model.Grupo === $api.Estruturadas.GrupoBemEnum.BemFinanceiro" />
          </v-col>
        </v-row>
        <v-row v-if="chave !== null" class="pt-2">
          <v-col cols="6" :chave="chave" v-if="chave !== '2_1' && chave && tipoPlaca !== 6">
            <input-number label="Valor Total da Garantia" v-model="model.VlrTotal" format="currency" :required="chave !==1 || produtoNotaComercialImovel" />
          </v-col>
          <v-col cols="6" v-if="produtoNotaComercialImovel">
            <input-number label="Valor do Imóvel para Fins de Leilão" format="currency" :rules="vlrMaximoLeilao" v-model="model.PropostaGarantiaBemImovel.ValorLeilao" required />
          </v-col>
          <v-col :cols="tipoPlaca === 6 || produtoNotaComercialImovel ? '12' : '6'">
            <input-textarea v-model="model.Descricao" label="Descrição" outlined class="overflow" />
          </v-col>
        </v-row>
      </template>
    </modal-form>
  </div>
</template>
<script>
export default {
  components: {
    BemMovel: () => import('./garantia/BemMovel.vue'),
    BemVeiculo: () => import('./garantia/BemVeiculo.vue'),
    BemImovel: () => import('./garantia/BemImovel.vue'),
    BemFinanceiro: () => import('./garantia/BemFinanceiro.vue'),
  },
  props: {
    proposta: { type: Object, default: null },
    value: null,
    registros: { type: Array, default: () => [] },
    tipoPessoa: null,
    isSAC: null,
  },
  data () {
    return {
      show: false,
      model: {
        CodigoProposta: this.$props.proposta.Codigo,
        PropostaGarantiaBemFinan: {
          PropostaGarantiaBemFinanCartao: [],
          PropostaGarantiaBemFinanSocio: [],
        },
        PropostaGarantiaBemImovel: {},
        PropostaGarantiaBemMovel: {},
        PropostaGarantiaBemVeiculo: {},
      },
      vlrRegistro: 0,
    }
  },
  computed: {
    bens () {
      let produto = []
      produto = this.$api.Estruturadas.TipoContrato.find(p => p.value === this.proposta.TipoContratoSigla)
      if (produto) {
        if (produto.grupo && parseInt(produto.grupo) === 4) {
          return this.$api.Estruturadas.GrupoBem
        } else {
          const grupoBens = this.$api.Estruturadas.GrupoBem.filter(z => z.value === parseInt(produto.grupo))
          return grupoBens
        }
      }
      return produto
    },
    tipoGarantia () {
      if (this.model.Grupo) {
        var lista = []
        const tipoPessoa = this.proposta.Cliente.TipoPessoa === 1 ? 'PF' : 'PJ'
        const listaParametro = this.$param.EST_PRODUTOS.find(p => p.TipoOperacao === this.proposta.TipoOperacaoCred && p.TipoPessoa === tipoPessoa).Produtos
        listaParametro.forEach(element => {
          if (element.garantias && element.Sigla === this.proposta.TipoContratoSigla) {
            element.garantias.map(g => {
              if (g.grupo === this.model.Grupo) {
                lista = g.value
              }
            })
          }
        })
        if (lista.length === 1) {
          this.$set(this.model, 'Subgrupo', lista[0].value)
        }
      }
      return lista
    },
    chave () {
      let chave = null
      if (this.model.Subgrupo) {
        const tipo = this.tipoGarantia.find(p => p.value === this.model.Subgrupo)
        if (tipo) { chave = tipo.value }
      }
      return chave
    },
    tipoPlaca () {
      return this.model.PropostaGarantiaBemVeiculo.TipoPlaca || null
    },
    produtoNotaComercialImovel () {
      return this.proposta.TipoContratoSigla === 'NCI'
    }
  },
  methods: {
    openModal (sender) {
      const th = this
      th.show = true
      th.$set(th, 'vlrRegistro', 0)
      if (sender) {
        const dto = {
          guidID: sender.Codigo
        }
        th.$api.Multiplo.Post('FindRecordPropostaGarantiaBem', dto).then(function (response) {
          if (th.$api.UI.PostLoadData(response, true)) {
            th.$api.UTIL.Functions.SetAllButNull(th, th, 'model', response)
            th.$set(th.model, 'Proprietario', response.DocumentoFederalProprietario === th.proposta.Cliente.DocumentoFederal ? 1 : 2)
            th.getValorRegistro()
          }
        })
      }
      th.$set(th.model, 'TipoOperacaoNome', th.proposta.TipoOperacaoNome)
      th.$set(th.model, 'TipoContratoDescricao', th.proposta.TipoContratoDescricao)
    },
    getValorRegistro: async function (grupo, subgrupo) {
      let vlr = 0
      if (this.model.VlrRegistro) {
        vlr = this.model.VlrRegistro
      } else if (this.model.Grupo && this.model.Subgrupo) {
        vlr = await this.$api.Estruturadas.GetValorRegistroGarantia(this, this.model, this.tipoPessoa, this.registros)
      }
      this.$set(this, 'vlrRegistro', vlr)
    },
    changeGrupo () {
      this.$set(this.model, 'Subgrupo', null)
      this.changeSubgrupo()
    },
    changeSubgrupo () {
      this.getValorRegistro()
    },
    changeProprietario () {
      if (this.model.Proprietario === 1) {
        this.$set(this.model, 'DocumentoFederalProprietario', this.proposta.Cliente.DocumentoFederal)
        this.$set(this.model, 'NomeProprietario', this.proposta.Cliente.Nome)
      } else {
        this.$set(this.model, 'DocumentoFederalProprietario', null)
        this.$set(this.model, 'NomeProprietario', null)
      }
    },
    submit () {
      const th = this
      th.createUpdateGarantiaBem()
      if (th.model.Grupo === th.$api.Estruturadas.GrupoBemEnum.BemMovel && th.chave === 1) {
        th.createUpdateDadosVeiculo()
      }
    },
    createUpdateGarantiaBem () {
      const th = this
      const obj = {
        dto: {
          Codigo: th.model.Codigo ? th.model.Codigo : th.$api.UI.Guid.New(),
          CodigoProposta: th.proposta.Codigo,
          CodigoIdentificador: th.model.CodigoIdentificador ? th.model.CodigoIdentificador : th.$api.UI.Guid.New(),
          NomeProprietario: th.model.NomeProprietario,
          DocumentoFederalProprietario: th.model.DocumentoFederalProprietario,
          Grupo: th.model.Grupo,
          Subgrupo: th.model.Subgrupo,
          VlrTotal: th.model.VlrTotal ? th.model.VlrTotal : th.model.PropostaGarantiaBemVeiculo.VlrFipe,
          Descricao: th.model.Descricao,
          PropostaGarantiaBemFinan: th.model.PropostaGarantiaBemFinan,
          PropostaGarantiaBemImovel: th.model.PropostaGarantiaBemImovel,
          PropostaGarantiaBemMovel: th.model.PropostaGarantiaBemMovel,
          PropostaGarantiaBemVeiculo: th.model.PropostaGarantiaBemVeiculo,
        }
      }
      obj.dto.PropostaGarantiaBemImovel.CEP = th.model.PropostaGarantiaBemImovel.CEP ? th.$api.UI.Format.SomenteNumeros(th.model.PropostaGarantiaBemImovel.CEP) : null
      if (th.model.PropostaGarantiaBemImovel.ValorLeilao) obj.dto.PropostaGarantiaBemImovel.ValorLeilao = th.model.PropostaGarantiaBemImovel.ValorLeilao
      th.$api.Multiplo.Post('CreateUpdatePropostaGarantiaBem', obj).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          if (!response.HasError) {
            th.show = false
            th.$emit('close', !response.error)
          } else {
            const { title, message } = th.$getErrorMessage('garantia.erroInclusao')
            th.$api.UI.ShowError(title, message)
          }
        }
      })
    },
    createUpdateDadosVeiculo () {
      const th = this
      const obj = {
        dto: {
          dto: {
            CodigoProposta: th.proposta.Codigo,
            CodigoOperacao: th.proposta.CodigoOperacao,
            NumeroProposta: th.proposta.CodigoProposta
          },
          dadosVeiculoDTO: {
            ...th.model.PropostaGarantiaBemVeiculo,
            CodigoIdentificador: th.model.CodigoIdentificador,
            DocumentoFederalProprietario: th.model.DocumentoFederalProprietario,
            Proprietario: th.model.NomeProprietario,
            Chassis: th.model.PropostaGarantiaBemVeiculo.Chassi,
            ignorarCpfRenave: true
          }
        }
      }
      th.$api.Multiplo.Post('CreateUpdatePropostaDadosVeiculo', obj).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          if (!response.HasError) {
            th.show = false
            th.$emit('close', !response.error)
          } else {
            const { title, message } = th.$getErrorMessage('proposta.generic')
            th.$api.UI.ShowError(title, message)
          }
        }
      })
    },
    vlrMaximoLeilao () {
      return [this.model.PropostaGarantiaBemImovel.ValorLeilao <= this.model.VlrTotal || 'Valor de Leilão deve ser menor ou igual que o Valor Total do Bem']
    },
  },
}
</script>
